import React from 'react';
import { Link } from 'react-router-dom';
import '../css/Home.css';

function Home() {
    return (
        <div>
            <div className="espaceHautAccueil"></div>
            <div className='d-flex text-center justify-content-center imgLivres'>
                <div className="row">
                    <img className='col-md-6 m-auto livre1' src="/img/livre_debout_1.webp" alt="Couverture La Clef - Astolie" />
                    <img className='col-md-6 m-auto livre2' src="/img/livre_debout_2.png" alt="Couverture La Clef - Les Chutes d'Est-cRive" />
                </div>
            </div>
            <div className="fondParchemin fondImagesAccueil">
                <div className='d-flex justify-content-center'>
                    <div className="row w-100">
                        <p>Plongez dans l'univers de La Clef, un monde en déclin, aux sentiers sinueux où se cachent de nombreux mystères. Suivez La Clef, une jeune femme énigmatique, dont le destin résonne avec ce monde en perdition. Partez pour une quête unique, mêlant réflexion et déduction, où chaque solution vous rapprochera un peu plus de la vérité. Laissez-vous emporter par une expérience unique et rejoignez la communauté de La Clef. </p>
                        <p>Serez-vous à la hauteur des défis pour déverrouiller les secrets de ce monde ? La Clef vous attend… Il ne reste plus qu’à la trouver. </p>
                    </div>
                </div>
                <div className='d-flex justify-content-center'>
                    <div className="row w-100">
                        <div className='infos infos-p1 col-lg-4'>
                            <img src="/img/lampe.png" alt="lampe infos" className="iconesPresentation" />
                            <h2 className='info-text-1 text-center'>Encre invisible</h2>
                            <h4 className='info-text-2 text-center'>Lampe UV</h4>
                            <p>Cette lampe est obligatoire pour résoudre les énigmes. L'encre invisible est présente sur certaines pages du livre.</p>
                        </div>
                        <div className='infos infos-p2 col-lg-4'>
                            <img src="/img/livre.png" alt="énigme infos" className="iconesPresentation" />
                            <h2 className='info-text-1 text-center'>Une énigme par double page</h2>
                            <h4 className='info-text-2 text-center'>Pas d'énoncé</h4>
                            <p>Sur chaque double page se trouve une énigme sans énoncé. À vous de mettre en relation le texte et l'image !<br /> <strong>Il y a 75 énigmes en tout !</strong></p>
                        </div>
                        <div className='infos infos-p3 col-lg-4'>
                            <img src="/img/www.png" alt="site infos" className="iconesPresentation" />
                            <h2 className='info-text-1 text-center'>Un site internet</h2>
                            <h4 className='info-text-2 text-center'>Un code</h4>
                            <p>Quelques énigmes vous mèneront sur internet. De plus si vous pensez avoir trouvé le code final,
                                si vous pensez avoir trouvé La clef...alors rendez-vous sur la page de <Link to="/Validation">validation</Link> du site !</p>
                        </div>
                    </div>
                </div>
            </div>


            <div className='d-flex justify-content-center'>
                <div className="row background-fin-key">
                    <div className='col-lg-3 clefAstolie'>
                        <a href="/fin">
                            <img src="/img/clef-1.webp" alt="cle" />
                        </a>
                        <a href="/fin" className="btn">
                            Résoudre le mystère<br />d'Astolie
                        </a>
                    </div>
                    <div className='col-lg-3 clefEstRive'>
                        <a href="/fin2">
                            <img src="/img/clef-2.webp" alt="cle" />
                        </a>
                        <a href="/fin2" className="btn">
                            Résoudre le mystère<br />d'Est-Rive
                        </a>
                    </div>
                    <div className='col-lg-3'>
                        <p className='subtitle'>Avez-vous trouvé<br />La Clef ?</p>
                    </div>
                    <div className='col-lg-3'>
                        &nbsp;
                    </div>
                </div>
            </div>
            <div className="sectionActus">
                <h2>Découvrez nos dernières actualités</h2>
                <div className="row backgroundActus">
                    <div className='col-lg-5 col-0'>
                        &nbsp;
                    </div>
                    <div className='col-lg-7 col-12 apercuActus'>
                        <div className="row">
                            <div className="col-md-6">
                                <img src="/img/image_actu_1.png" alt="Actu tome 2" />
                                <h3>La Clef - tome 2</h3>
                                <p>Le tome 2 de La Clef arrive bientôt !</p>
                                {/* <a style="font-weight=700;" href="#">Lire la suite </a> */}
                            </div>
                            <div className="col-md-6">
                                <img src="/img/image_actu_3.png" alt="Actu tome 2" style={{ height: "200px" }} />
                                <h3>Festival International des jeux de Cannes</h3>
                                <p>Nous serons au Festival International des Jeux de Cannes du 28 février au 2 mars 2025</p>
                                {/* <a style="font-weight:700;">Lire la suite </a> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default Home;
